import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import './MedicationForms.css';
import { fetchUserProfile, saveMedicationMetaDoc, fetchFormDataMedication } from '../services/Service';
import axios from "axios";
import Select from 'react-select';
import MedicationsList from '../assessment/MedicationsList';
import MedicationsSupplierList from '../assessment/MedicationsSupplierList';
import LocationDisplay from '../OCRDocument/LocationDisplay';


const MedicationFormsMetaDoc = ({ closeModal, selectedServiceRecord, callHomeBasedServicesHistory, membershipNoMember, aiBupaServiceRecommendations, getAiBupaServiceRecommendations }) => {

    const qsParams = useParams();
    const userId = qsParams.memberId;

    const [error, setError] = useState("");
    const [message, setMessage] = useState("");
    const [showOcr, setShowOcr] = useState("");
    const [disabledButton, setDisabledButton] = useState(true);
    const [cityList, setCityList] = useState([]);
    const [frequencyList, setFrequencyList] = useState([]);
    const [partnerList, setPartnerList] = useState([]);
    const [pharmacyList, setPharmacyList] = useState([]);

    const today = new Date();
    const formattedDate = today.toISOString().split('T')[0];



    const medicationsObj = {
        productId: '',
        productName: '',
        quantity: '',
        comments: '',
        frequency: '',
        duration: '',
        supplyFrom: formattedDate,
        supplyTo: '',
        sfdaCode: '',
        source: '',
        recommendationId: ''
    }

    const supplierObj = {
        productId: '',
        productName: '',
        quantity: '',
        comments: '',
        sfdaCode: '',
        source: '',
        recommendationId: ''
    }

    let aiBupaMedicines = [];
    if (aiBupaServiceRecommendations[0]?.medicines?.length > 0) {
        aiBupaMedicines = aiBupaServiceRecommendations[0]?.medicines
            ?.filter(item => item.matchFound === 'Y' && item.medType === 'medications')
            ?.map((item) => ({
                productId: item.medicineId || '',
                productName: item.serviceDesc || '',
                quantity: item.servicelineItemQuantity || '',
                comments: '',
                frequency: item.calculatedFrequencyId || '',
                supplyFrom: item.calculatedSupplyFrom || '',
                supplyTo: item.calculatedSupplyTo || '',
                duration: item.calculatedDuration || '',
                sfdaCode: item.serviceCode || '',
                source: item.dataSource || '',
                recommendationId: item.recommendationId
            }));
    }


    let aiBupaMedicinesSupplies = [];
    if (aiBupaServiceRecommendations[0]?.medicines?.length > 0) {
        aiBupaMedicinesSupplies = aiBupaServiceRecommendations[0]?.medicines
            ?.filter(item => item.matchFound === 'Y' && item.medType === 'supplies')
            ?.map((item) => ({
                productId: item.medicineId || '',
                productName: item.serviceDesc || '',
                quantity: item.servicelineItemQuantity || '',
                comments: '',
                sfdaCode: item.serviceCode || '',
                source: item.dataSource || '',
                recommendationId: item.recommendationId
            }));
    }


    const [formData, setFormData] = useState({
        userId: userId,
        selectedServiceRecord: selectedServiceRecord,
        membership: '',
        name: '',
        mobileNumber: '',
        partnerClinic: '',
        remarks: '',
        nationality: '',
        pharmacy: '',
        labProviderName: '',
        deliveryRefill: '',
        orderType: '',
        city: '',
        district: '',
        deductible: '',
        medications: (aiBupaServiceRecommendations[0]?.medicines?.filter(item => item.matchFound === 'Y' && item.medType === 'medications')?.length > 0) ? aiBupaMedicines : '',
        cityId: '',
        address: '',
        latitude: '',
        longitude: '',
        imageUrl: '',
        addressType: '',
        mediaUrl: '',
        flowId: '',
        supplierMedications: (aiBupaServiceRecommendations[0]?.medicines?.filter(item => item.matchFound === 'Y' && item.medType === 'supplies')?.length > 0) ? aiBupaMedicinesSupplies : ''
    });

    const [addMedicationsComponentCount, setAddMedicationsComponentCount] = useState(formData.medications.length);
    const [addSuppliesComponentCount, setAddSuppliesComponentCount] = useState(formData.medications.length);

    // Sample OCR data
    const [ocrData, setOcrData] = useState({
        medications: [
            {
                productName: '',
                quantity: '',
                frequency: '',
                duration: '',
                supplyFrom: '',
                supplyTo: ''
            }
        ],
        additionalInfo: ''
    });

    useEffect(() => {
        dropdownData();
        fetchUserData();
    }, [])


    const fetchUserData = async () => {
        const request = axios.CancelToken.source();
        let ct = {
            cancelToken: request.token
        }
        setDisabledButton(true);
        await fetchUserProfile(userId, 'metaService-med')
            .then((response) => {
                if (response.data.code === 200) {

                    setFormData((prev) => ({
                        ...prev, membership: response.data.data.info.membershipNumber, name: response.data.data.info.memberName, mobileNumber: response.data.data.info.mobile, nationality: response.data.data.info.nationality, cityId: response.data.data.info.cityId, city: response.data.data.info.cityName,
                        addressType: response.data.data.info.addressType, address: response.data.data.info.address, latitude: response.data.data.info.latitude, longitude: response.data.data.info.longitude, imageUrl: response.data.data.info.imageUrl, mediaUrl: response.data.data.info.mediaUrl,
                        deliveryRefill: response.data.data.info.deliveryRefill, orderType: response.data.data.info.orderType, partnerClinic: response.data.data.info.partnerClinic, pharmacy: response.data.data.info.pharmacyId, labProviderName: response.data.data.info.pharmacyName,flowId: response.data.data.info.flowId
                    }));

                    setShowOcr(response.data.data.info.showOcr);

                    if (response.data.data.info.cityId > 0) {
                        fetchCategoryList(response.data.data.info.cityId);
                    }

                    if (response.data.data.info.showOcr == true) {  
                        const formattedMeds = (response.data.data.info.ocrMedcine || []).map(med => ({
                            productName: med.serviceDesc || '',
                            quantity: med.servicelineItemQuantity || '',
                            frequency: med.frequencyName || '',
                            duration: med.calculatedDuration || '',
                            supplyFrom: med.calculatedSupplyFrom || '',
                            supplyTo: med.calculatedSupplyTo || ''
                        }));

                        setOcrData(prev => ({
                            ...prev,
                            medications: formattedMeds,
                            additionalInfo: response.data.data.info.additionalInfo
                        }));
                    }

                    setDisabledButton(false);
                } else {
                    setError(response.data.data.message);
                }
            }).catch(function (error) {
                console.log(error);
            });
        return () => request.cancel();
    }


    const handleChange = async (e) => {
        const { name, value } = e.target;

        const updatedFormData = { ...formData, [name]: value };

        if (name === "pharmacy") {
            updatedFormData.labProviderName = e.target.selectedOptions[0].text;
        }

        if (name === "mobileNumber") {
            if (!value.startsWith('0')) {
                updatedFormData.mobileNumber = ('0' + value).slice(0, 11);
            } else if (value.length === 1 && value === '0') {
                updatedFormData.mobileNumber = '0';
            } else {
                updatedFormData.mobileNumber = value.slice(0, 11);
            }
        }

        setFormData(updatedFormData);

        setError('');
    };

    const validateForm = () => {
        const mandatoryFields = ['membership', 'name', 'mobileNumber', 'partnerClinic','deliveryRefill', 'orderType', 'city', 'nationality'];

        if(formData['deliveryRefill'] == 'pickup'){
            mandatoryFields.push('pharmacy');
        }

        for (let field of mandatoryFields) {
            if ((field === 'city')) {
                if (formData[field] == "") {
                    setError('Enter all mandatory fields');
                    return false;
                }
            } else if (!formData[field].trim()) {
                setError('Enter all mandatory fields');
                return false;
            }


        }

        return true;
    };

    const handleChangeCity = (selectedOption) => {
        fetchCategoryList(selectedOption.value);
        setFormData({
            ...formData,
            ['city']: selectedOption.label,
            ['cityId']: selectedOption.value,
        });
    };

    const fetchCategoryList = async (cityName) => {
        const request = axios.CancelToken.source();
        let ct = {
            cancelToken: request.token
        }
        await fetchFormDataMedication(cityName, formData['membership'])
            .then((response) => {
                if (response.data.code === 200) {
                    setPharmacyList(response.data.data.pharmacy);
                } else {
                    setError(response.data.data.message);
                }
            }).catch(function (error) {
                console.log(error);
            });
        return () => request.cancel();
    }

    const handleSubmit = async (event) => {
        setError('');
        event.preventDefault();
        if (validateForm()) {
            const request = axios.CancelToken.source();
            let ct = {
                cancelToken: request.token
            }
            setDisabledButton(true);
            await saveMedicationMetaDoc(formData)
                .then((response) => {
                    if (response.data.code === 200) {

                        getAiBupaServiceRecommendations(membershipNoMember);
                        setMessage(response.data.data.message);
                        callHomeBasedServicesHistory();
                        setTimeout(() => {
                            closeModal();
                        }, 1000);
                    } else {
                        setMessage('');
                        setError(response.data.data.message);
                        setDisabledButton(false);
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            return () => request.cancel();
        }
    }


    const dropdownData = async () => {
        const request = axios.CancelToken.source();
        let ct = {
            cancelToken: request.token
        }
        await fetchFormDataMedication()
            .then((response) => {
                if (response.data.code === 200) {
                    setCityList(response.data.data.city);
                    setPharmacyList(response.data.data.pharmacy);
                    setPartnerList(response.data.data.partner);
                    setFrequencyList(response.data.data.frequency);
                } else {
                    setError(response.data.data.message);
                }
            }).catch(function (error) {
                console.log(error);
            });
        return () => request.cancel();
    }


    const addComponent = () => {
        setFormData(prevState => ({
            ...prevState,
            medications: [...prevState.medications, medicationsObj]
        }));
        setAddMedicationsComponentCount(prev => prev + 1);
        // if (addMedicationsComponentCount >= 1) {
        //     setShowRemove(true);
        // }
        setFormData({
            ...formData,
            medications: [...formData.medications, medicationsObj]
        });

    };


    const addSupplierComponent = () => {
        setFormData(prev => ({
            ...prev,
            supplierMedications: [...prev.supplierMedications, supplierObj]
        }));

        setAddSuppliesComponentCount(prev => prev + 1);
        // if (addSuppliesComponentCount >= 1) {
        //     setShowRemoveSupply(true);
        // }
        setFormData({
            ...formData,
            supplierMedications: [...formData.supplierMedications, supplierObj]
        });
    };

    const handleFieldChange = (e, index, listType) => {
        
        if (listType == 'medications') {
            const { name, value } = e.target;
            const list = [...formData.medications];
            list[index][name] = value;
            if (name == "productId") {
                list[index]["code"] = ''
                list[index]["productName"] = ''
            }

            setFormData({ ...formData, medications: list });
        } else {
            const { name, value } = e.target;
            const list = [...formData.supplierMedications];
            list[index][name] = value;

            setFormData({ ...formData, supplierMedications: list });
        }

    }


    const removeComponent = (index) => {
        setFormData((prevFormObject) => {
            const newArr = [...prevFormObject.medications];
            newArr.splice(index, 1);
            return { ...prevFormObject, medications: newArr };
        });
        // if (addMedicationsComponentCount < 3) {
        //     setShowRemove(false);
        // }
        setAddMedicationsComponentCount(prevCount => prevCount - 1);
    };

    const removeSupplierComponent = (index) => {
        setFormData((prevFormData) => {
            const newArr = [...prevFormData.supplierMedications];
            newArr.splice(index, 1);
            return { ...prevFormData, supplierMedications: newArr };
        });
    };

    const handleSuggestionClick = (suggestion, medicationType, index) => {

        if (medicationType == 'medications') {
            const foundProduct = aiBupaMedicines.find(
                (item) => item.productId === suggestion.productId
            );

            const list = [...formData.medications];
            list[index]['productId'] = suggestion.productId;
            list[index]['productName'] = suggestion.productName;
            list[index]['sfdaCode'] = suggestion.sfdaCode;

            if (foundProduct) {
                list[index]['quantity'] = foundProduct.quantity;
                list[index]['source'] = foundProduct.source;
                list[index]['recommendationId'] = foundProduct.recommendationId;
            }
            setFormData({ ...formData, medications: list });
        } else {

            const foundProductSupplier = aiBupaMedicinesSupplies.find(
                (item) => item.productId === suggestion.productId
            );

            const listSupplier = [...formData.supplierMedications];
            listSupplier[index]['productId'] = suggestion.productId;
            listSupplier[index]['productName'] = suggestion.productName;
            listSupplier[index]['sfdaCode'] = suggestion.sfdaCode;

            if (foundProductSupplier) {
                listSupplier[index]['quantity'] = foundProductSupplier.quantity;
                listSupplier[index]['source'] = foundProductSupplier.source;
                listSupplier[index]['recommendationId'] = foundProductSupplier.recommendationId;
            }

            setFormData({ ...formData, supplierMedications: listSupplier });
        }

    };


    return (
        <>

            <div className='col-md-12'>
                <div className='card card-task-appoint'>
                    <div className='card-body'>
                        <div className='card-text'></div>
                        <form id="medicationForm" onSubmit={handleSubmit}>
                            <div className="tw-flex tw-items-start tw-w-full tw-gap-4">
                                {aiBupaServiceRecommendations[0]?.medicines?.filter(item => item.matchFound === 'N')?.length > 0 && (
                                    <div className="tw-flex-grow">
                                        <div className="col-md-12 mb-3">
                                            <div className="col mb-2">Recommended Medications</div>
                                            <div className="profile-box-n1 p-2 ps-3 border" style={{ backgroundColor: "#ffedd7" }}>
                                                <div className="row align-items-center">
                                                    <div className="info-line col">
                                                        <div className="row">
                                                            {aiBupaServiceRecommendations[0]?.medicines?.filter(item => item.matchFound === 'N')?.map((refillItem, refillIndex) => (
                                                                <div className="col-md-6 margin-mb" key={`refill-${refillIndex}`}>
                                                                    <h5 className="program mb-0">
                                                                        <i className="bi bi-capsule-pill me-2" style={{ color: "#267ca1", fontSize: "16px" }} aria-hidden="true"></i>
                                                                        {refillItem.serviceDesc + " - " + refillItem.servicelineItemQuantity}
                                                                    </h5>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                                {formData.mediaUrl && 
                                    <div className="tw-flex tw-flex-col tw-items-start tw-flex-shrink-0 tw-w-32 mb-2">
                                        <span className="tw-mb-2 tw-text-base" style={{ color: '#212529' }}>View Original</span>
                                        <a
                                            href={formData.mediaUrl}
                                            download
                                            target="_blank"
                                            className="tw-py-3 tw-px-4 tw-rounded-xl hover:tw-bg-gray-200 tw-transition-colors border tw-cursor-pointer"
                                        >
                                            <i className="bi bi-eye"></i>
                                        </a>
                                    </div>
                                }
                            </div>
                            <div className='row'>
                                <div className='col-md-6 mb-3'>
                                    <div className="row">
                                        <div className='col-md-6 mb-1'>
                                            <label className="form-label">Membership</label>
                                            <h5 className='name-label-field' name="membership">{formData['membership']}</h5>
                                        </div>
                                        <div className='col-md-6 mb-1'>
                                            <label className="form-label">Name</label>
                                            <h5 className='name-label-field' name="name">{formData['name']}</h5>
                                        </div>
                                        <div className='col-md-6 mb-3 mt-4'>
                                            <label className="form-label">Mobile Number
                                                <span className='text-danger'>*</span></label>
                                            <input type="text" name="mobileNumber" className='form-control control-input-ui' value={formData['mobileNumber']} onChange={handleChange} />
                                        </div>
                                        <div className='col-md-6 mb-3 mt-4'>
                                            <label className="form-label"> Partner Clinic
                                                <span className='text-danger'>*</span></label>
                                            <select className="form-select select-input-ui" name="partnerClinic" id="partnerClinic" value={formData['partnerClinic']} onChange={handleChange} >
                                                <option value="">-- Select Partner Clinic --</option>
                                                {partnerList.map(option => (
                                                    <option key={option.id} value={option.id}>{option.partnerName}</option>
                                                ))}
                                            </select>
                                        </div>

                                        <div className='col-md-6 mb-3'>
                                            <label className="form-label">Nationality
                                                <span className='text-danger'>*</span>
                                            </label>
                                            <select className="form-select select-input-ui" name="nationality" id="nationality" value={formData['nationality']} onChange={handleChange} >
                                                <option value="">-- Select Nationality --</option>
                                                <option value="Saudi Arabian">Saudi Arabian</option>
                                                <option value="Non Saudi Arabian">Non Saudi Arabian</option>
                                            </select>
                                        </div>

                                        <div className='col-md-3 mb-3'>
                                            <label className="form-label">District</label>
                                            <input type="text" name="district" className='form-control control-input-ui' value={formData['district']} onChange={handleChange} />
                                        </div>

                                        <div className='col-md-3 mb-3'>
                                            <label className="form-label"> Deductible</label>
                                            <input type="text" name="deductible" className='form-control control-input-ui' value={formData['deductible']} onChange={handleChange} />
                                        </div>
                                    </div>
                                </div>

                                <div className='col-md mb-3 '>
                                    <div className="tw-grid tw-grid-cols-2 tw-gap-6">
                                        <div>
                                            <div className=' mb-3'>
                                                <label className="form-label"> Delivery Type
                                                    <span className='text-danger'>*</span>
                                                </label>
                                                <select className="form-select select-input-ui" name="deliveryRefill" id="deliveryRefill" value={formData['deliveryRefill']} onChange={handleChange} >
                                                    <option value="">-- Select Delivery Type --</option>
                                                    <option value="delivery">Delivery</option>
                                                    <option value="pickup">Pickup</option>
                                                </select>
                                            </div>

                                            <div className=' mb-3'>
                                                <label className="form-label">City
                                                    <span className='text-danger'>*</span>
                                                </label>

                                                <Select
                                                    value={cityList.find(option => option.label === formData.city) || null}
                                                    onChange={handleChangeCity}
                                                    options={cityList}
                                                    isSearchable={true}
                                                    placeholder="Select City"
                                                    className="form-control select-input-ui select-input-ui-select"
                                                />
                                            </div>
                                            
                                            <div className=' mb-3'>
                                                <label className="form-label">Remarks</label>
                                                <input type="text" name="remarks" className='form-control control-input-ui' value={formData['remarks']} onChange={handleChange} />
                                            </div>
                                        </div>

                                       <div>
                                            <div className=' mb-3'>
                                                <label className="form-label"> Order Type
                                                    <span className='text-danger'>*</span></label>
                                                <select className="form-select select-input-ui" name="orderType" id="orderType" value={formData['orderType']} onChange={handleChange} >
                                                    <option value="">-- Select Order Type --</option>
                                                    <option value="1">Refill</option>
                                                    <option value="2">New Prescription</option>
                                                </select>
                                            </div>

                                            {formData['deliveryRefill'] == 'pickup' && 
                                                <div className=' mb-3'>
                                                    <label className="form-label">Pharmacy
                                                        <span className='text-danger'>*</span>
                                                    </label>
                                                    <select className="form-select select-input-ui" name="pharmacy" id="pharmacy" value={formData['pharmacy']} onChange={handleChange} >
                                                        <option value="">-- Select Pharmacy --</option>
                                                        {pharmacyList?.map(option => (
                                                            <option key={option.id} value={option.id}>{option.pharmacyName}</option>
                                                        ))}
                                                    </select>
                                                </div>
                                            }
                                        </div>
                                        
                                    </div>
                                </div>


                                {showOcr &&
                                    <div className='col-md-12 mb-3'>
                                        <div className="row">
                                            {formData.addressType != "" &&
                                                <div className="col-md-12 mb-3">
                                                    <h5 className='name-label-field' style={{ height: 'auto', marginBottom: '15px' }}>Delivery Information</h5>
                                                    <LocationDisplay locationData={formData} />
                                                </div>
                                            }

                                            {/* <div className="col-md-6">
                                                <h5 className='name-label-field' style={{ height: 'auto', marginBottom: '10px' }}>Extracted Information from Document</h5>
                                                <div className="card">
                                                    <div className="card-body">
                                                        <OcrDataDisplay data={ocrData} />
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-md-6">
                                                <h5 className='name-label-field' style={{ height: 'auto', marginBottom: '10px' }}>Source Document</h5>
                                                <div className="card">
                                                    <div className="card-body">
                                                        <iframe
                                                            src={formData.mediaUrl}
                                                            title="Current Page"
                                                            width="100%"
                                                            height="300px"
                                                            style={{ border: "1px solid #ccc" }}
                                                        /> 
                                                    </div>
                                                </div>
                                            </div> */}
                                        </div>
                                    </div>
                                }

                                <div className='col-md-12 mb-0'>
                                    <div className='col-md-12 mb-0'>
                                        <h5 className='name-label-field' style={{ height: 'auto', marginBottom: '0' }}> Medications</h5>
                                        {formData.medications.length > 0 && (
                                            <div className='col-12'>
                                                <div className="table-responsive">
                                                    <table className="table table-borderless mb-0">
                                                        <thead>
                                                            <tr>
                                                                <td className='ps-0 pb-1'>Product <span className='text-danger'>*</span></td>
                                                                <td className='ps-0 pb-1'>Frequency <span className='text-danger'>*</span></td>
                                                                <td className='ps-0 pb-1'>Duration <span className='text-danger'>*</span></td>
                                                                <td className='ps-0 pb-1'>Quantity <span className='text-danger'>*</span></td>
                                                                <td className='ps-0 pb-1'>Supply From <span className='text-danger'>*</span></td>
                                                                <td className='ps-0 pb-1'>Supply To <span className='text-danger'>*</span></td>
                                                                <td className='ps-0 pb-1'>Comments</td>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {formData.medications.map((medication, index) => (
                                                                <MedicationsList c={index} key={index} showRemoveButton={true} handleFieldChange={handleFieldChange} data={medication} frequencyData={frequencyList} removeComponent={removeComponent} listType="medications" handleSuggestionClick={handleSuggestionClick} />

                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>

                                        )}
                                    </div>
                                    <div className='col-md-12 text-center mb-4'>
                                        <button type="button" className="btn btn-primary addNewRow-btn" onClick={() => addComponent()}><i className="bi bi-plus"></i> Add </button>
                                    </div>

                                    <div className="col-12"><hr /></div>

                                    <div className='col-md-12 mb-0'>
                                        <h5 className='name-label-field' style={{ height: 'auto', marginBottom: '0' }}> Supplies</h5>

                                        {formData.supplierMedications?.length > 0 && (
                                            <div className='col-12'>
                                                <div className="table-responsive">
                                                    <table className="table table-borderless mb-0">
                                                        <thead>
                                                            <tr>
                                                                <td className='ps-0 pb-1'>Product <span className='text-danger'>*</span></td>
                                                                <td className='ps-0 pb-1'>Quantity <span className='text-danger'>*</span></td>
                                                                <td className='ps-0 pb-1'>Comments</td>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {formData.supplierMedications?.map((medication, index) => (
                                                                <MedicationsSupplierList
                                                                    c={index}
                                                                    key={index}
                                                                    showRemoveButton={true}
                                                                    handleFieldChange={handleFieldChange}
                                                                    data={medication}
                                                                    frequencyData={frequencyList}
                                                                    removeComponent={removeSupplierComponent}
                                                                    listType="supplies"
                                                                    handleSuggestionClick={handleSuggestionClick}
                                                                />
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>

                                        )}
                                    </div>

                                    <div className='col-md-12 text-center mb-4'>
                                        <button type="button" className="btn btn-primary addNewRow-btn" onClick={() => addSupplierComponent()}>
                                            <i className="bi bi-plus"></i> Add
                                        </button>
                                    </div>

                                    <div className="col-12"><hr /></div>

                                    <div className='col-md-12 text-center mt-3'>
                                        <div className={`${error != "" ? "errorDiv" : "hide"}`}>{error}</div>
                                        <div className={`${message != "" ? "messageDiv" : "hide"}`}>{message}</div>
                                        <Button variant="primary" type="submit" className="btn btn-primary save-btn" disabled={disabledButton}>Save Medication Request</Button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div >
                </div >
            </div >
        </>
    )
}

export default MedicationFormsMetaDoc;